import styled from 'styled-components'
import { breakpoints, colors } from 'style'

export const HomeCardsContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${colors.white};
  .container {
    h3 {
      display: none;
    }
  }
  @media (max-width: ${breakpoints.sm}px) {
    padding: 17px 0;
    .container {
      h3 {
        display: block;
      }
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
